import React from 'react';
import { cx } from '@linaria/atomic';
import { Text, type TextProps } from '../../text/text.component';
import * as styles from '../index-row.styles';
import { useIndexRowItemContext } from './index-row-item';

type IndexRowTailProps = {
  children: React.ReactNode;
  isInteractive?: boolean;
} & TextProps;

export const IndexRowTail = ({ children, isInteractive = true, className, ...rest }: IndexRowTailProps) => {
  const { disabled } = useIndexRowItemContext();

  return (
    <div
      onClick={typeof children === 'string' || !isInteractive ? undefined : (e) => e.stopPropagation()}
      className={styles.marginLeftAutoStyle}
    >
      {typeof children === 'string' ? (
        <Text
          color='light'
          className={cx(styles.truncatedTextStyle, disabled && styles.halfOpacityStyle, className)}
          {...rest}
          size='medium'
        >
          {children}
        </Text>
      ) : (
        children
      )}
    </div>
  );
};

IndexRowTail.displayName = 'IndexRowTail';
